import unparkRoutes from './routes'

/* @ngInject */
const unparkRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(unparkRoutes.index.path, {
      url: unparkRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'unparkCtrl',
    })
    .state(unparkRoutes.selectWagons.path, {
      url: unparkRoutes.selectWagons.url,
      template: require('./templates/selectWagons.html'),
    })
    .state(unparkRoutes.createTrain.path, {
      url: unparkRoutes.createTrain.url,
      template: require('./templates/createTrain.html'),
    })
    .state(unparkRoutes.report.path, {
      url: unparkRoutes.report.url,
      template: require('./templates/report.html'),
    })
}

export default unparkRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/unpark/unpark.routes.js